'use client';
import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import LouiseButton from '@/components/buttons/LouiseButton';

type Props = { locale: string };

function JoinToPartner({ locale }: Props) {
  const { t } = useTranslation(locale);
  return (
    <section className="tw-pt-16 lg:tw-pt-20">
      <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-max-w-7xl">
        <div className="tw-text-center">
          <div className="tw-bg-gradient-to-r tw-from-blue-600 tw-to-purple-600 tw-rounded-2xl tw-p-8 sm:tw-p-12 tw-text-white">
            <h3 className="tw-text-2xl sm:tw-text-3xl tw-font-bold tw-mb-4 tw-font-['Lexend'] tw-text-white">
              {t('CtaPartnerPrograms/title')}
            </h3>
            <p className="tw-text-blue-100 tw-mb-8 tw-max-w-2xl tw-mx-auto tw-font-['Lexend']">
              {t('CtaPartnerPrograms/description')}
            </p>
            <LouiseButton color="white" cta={t('CtaPartnerPrograms/cta')} ctaTarget="register" locale={locale} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default JoinToPartner;
